// extracted by mini-css-extract-plugin
export default {"Box":"BlameAgeLegend-module__Box--EZ5He","Text":"BlameAgeLegend-module__Text--bdSBv","Box_1":"BlameAgeLegend-module__Box_1--l6Ibv","Text_1":"BlameAgeLegend-module__Text_1--cLTTt"};